import { useEffect } from 'react';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { DashboardBillingSection } from '@/components/dashboard/DashboardPanels';
import { useDashboardSite } from '@/pages/dashboard/DashboardSiteContext';
import { DashboardHowItWorksLink } from '@/pages/dashboard/DashboardHelpPage';

export default function DashboardBillingPage() {
  const { refreshBilling, selectedSiteId } = useDashboardSite();

  useEffect(() => {
    void refreshBilling().catch(() => undefined);
  }, [selectedSiteId]);

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Billing</h2>
        <p className="text-sm text-muted-foreground">
          Prepaid balance, top-ups, auto-recharge, and chatbot runtime.{' '}
          <DashboardHowItWorksLink hash="get-started" />
        </p>
      </div>
      <DashboardBillingSection />
      {!selectedSiteId ? (
        <Card>
          <CardHeader>
            <CardTitle>Chatbot runtime</CardTitle>
            <CardDescription>
              Claim or select a site above to start, stop, and monitor hourly chatbot runtime.
            </CardDescription>
          </CardHeader>
        </Card>
      ) : null}
    </div>
  );
}
